import PropTypes from 'prop-types'

import TableError from 'components/table/TableError'
import Loading from 'components/loading/Loading'

const TableBody = ({
  column = 1,
  loading = false,
  error = false,
  empty = false,
  emptyMessage = null,
  loadingMessage = <Loading />,
  errorMessage = <TableError />,
  children,
  className,
}) => (
  <tbody className={className}>
    {(error && (
      <tr>
        <td colSpan={column} className="nodata_info">
          <div className="inner_tbl">{errorMessage}</div>
        </td>
      </tr>
    )) ||
      (loading && loadingMessage && (
        <tr>
          <td colSpan={column} className="nodata_info">
            {loadingMessage}
          </td>
        </tr>
      )) ||
      (empty && (
        <tr>
          <td colSpan={column} className="nodata_info">
            {!loading && emptyMessage}
          </td>
        </tr>
      )) || <>{children}</>}
  </tbody>
)

export default TableBody

TableBody.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  column: PropTypes.number,
  empty: PropTypes.bool,
  emptyMessage: PropTypes.node,
  error: PropTypes.bool,
  errorMessage: PropTypes.node,
  loading: PropTypes.bool,
  loadingMessage: PropTypes.node,
}
